export default "__VITE_ASSET__B3Azu05C__"